<template>
  <b-modal id="choice-modal" ref="imageChoiceModal" :hide-header="true" :hide-footer="true" :no-close-on-backdrop="true">
    <div>
      <b-button @click="hideModal()" aria-label="Close" class="close"><b-icon-x font-scale="2"></b-icon-x></b-button>
    </div>
    <div class="text-left">
      <p class="h6">どちらの画像に手描きをしますか。</p>
    </div>
    <div class="form-group row" style="margin: 30px 30px">
      <div class="col-sm-6 row h-100">
        <p class="h7 text-center">受注時の手書き画像</p>
        <img :src="getImageA()" class="h-100 ar-3-2">
        <b-button variant="primary" @click="imgChoice(0)" class="image-set-btn">選択</b-button>
      </div>
      <div class="col-sm-2 row"/>
      <div class="col-sm-6 row h-100">
        <p class="h7 text-center">前回の制作指示画像</p>
        <img :src="getImageB()" class="h-100 ar-3-2">
        <b-button variant="primary" @click="imgChoice(1)" class="image-set-btn">選択</b-button>
      </div>
    </div>
  </b-modal>
</template>
<script>
export default {
  name: 'ImageChoiceModal',
  data () {
    return {
      imageA: '',
      imageB: ''
    }
  },
  methods: {
    showModal (imageA, imageB) {
      this.imageA = imageA
      this.imageB = imageB
      this.$refs.imageChoiceModal.show()
    },
    hideModal () {
      this.$refs.imageChoiceModal.hide()
    },
    getImageA () {
      return this.imageA
    },
    getImageB () {
      return this.imageB
    },
    imgChoice (choiceNum) {
      if (choiceNum === 0) {
        this.$emit('ImageA')
      } else {
        this.$emit('ImageB')
      }
      this.$refs.imageChoiceModal.hide()
    }
  }
}
</script>
<style>
.image-set-btn {
  margin: 5px auto;
}
.h7{
  font-size: 0.8rem;
}
.text-center {
  margin-left: auto;
  margin-right: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/ImageChoiceModal.vue